/* eslint-disable */
/**
 * Shared Multilingual Dictionary for BPG Calculators (1 to 6) and Results (1 to 6)
 * Supports: AZ (Azerbaijani), ENG (English), RU (Russian), TR (Turkish)
 */

export const t = (dict, lang, defaultText = '') => {
  if (!dict) return defaultText;
  if (typeof dict === 'string') return dict;
  return dict[lang] || dict['AZ'] || dict['ENG'] || defaultText;
};

export const calcCommon = {
  mainWorkplace: {
    AZ: '🏢 Əsas İş Yeri (200 ₼ güzəştlə)',
    ENG: '🏢 Main Workplace (200 ₼ exemption)',
    RU: '🏢 Основное место работы (льгота 200 ₼)',
    TR: '🏢 Asıl İş Yeri (200 ₼ muafiyetli)',
  },
  additionalWorkplace: {
    AZ: '💼 Əlavə İş Yeri',
    ENG: '💼 Additional Workplace',
    RU: '💼 Дополнительное место работы',
    TR: '💼 Ek İş Yeri',
  },
  grossToNet: {
    AZ: 'Gross ➔ Net',
    ENG: 'Gross ➔ Net',
    RU: 'Gross ➔ Net',
    TR: 'Brüt ➔ Net',
  },
  netToGross: {
    AZ: 'Net ➔ Gross',
    ENG: 'Net ➔ Gross',
    RU: 'Net ➔ Gross',
    TR: 'Net ➔ Brüt',
  },
  calculateBtn: {
    AZ: 'Hesabla',
    ENG: 'Calculate',
    RU: 'Рассчитать',
    TR: 'Hesapla',
  },
  recalculateBtn: {
    AZ: 'Yenidən Hesabla',
    ENG: 'Calculate Again',
    RU: 'Рассчитать заново',
    TR: 'Yeniden Hesapla',
  },
  downloadPdfBtn: {
    AZ: 'Rəsmi PDF Hesabatı İndir',
    ENG: 'Download Official PDF',
    RU: 'Скачать официальный отчет PDF',
    TR: 'Resmi PDF Raporunu İndir',
  },
  totalTakeHome: {
    AZ: 'Xalis Əməkhaqqı (Net / Ələ çatan)',
    ENG: 'Net Salary (Take Home)',
    RU: 'Чистая зарплата к получению (Net)',
    TR: 'Net Ele Geçen Maaş (Net)',
  },
  superGrossTitle: {
    AZ: 'Ümumi Maya Dəyəri (Super Gross)',
    ENG: 'Total Employer Cost (Super Gross)',
    RU: 'Полные затраты работодателя (Super Gross)',
    TR: 'Toplam İşveren Maliyeti (Super Gross)',
  },
  days: {
    AZ: 'gün',
    ENG: 'days',
    RU: 'дней',
    TR: 'gün',
  },
  aznSymbol: '₼',
};

// Sector Options (Used in Calc 1, 2, etc.)
export const sectorOptions = [
  {
    id: 'PRIVATE',
    value: 'private_non_oil',
    name: {
      AZ: 'Qeyri-dövlət və qeyri-neft sektoru (Özəl)',
      ENG: 'Non-state & non-oil sector (Private)',
      RU: 'Негосударственный и ненефтяной сектор (Частный)',
      TR: 'Devlet dışı ve petrol dışı sektör (Özel)',
    },
  },
  {
    id: 'STATE',
    value: 'state_or_oil',
    name: {
      AZ: 'Dövlət və neft-qaz sektoru',
      ENG: 'State & oil-gas sector',
      RU: 'Государственный и нефтегазовый сектор',
      TR: 'Devlet ve petrol-gaz sektörü',
    },
  },
];

// Tax Exemption Options (Article 102)
export const exemptionOptions = [
  {
    amount: 0,
    value: 0,
    label: {
      AZ: 'Güzəşt yoxdur (0 AZN)',
      ENG: 'No exemption (0 AZN)',
      RU: 'Без льготы (0 AZN)',
      TR: 'Muafiyet yok (0 AZN)',
    },
  },
  {
    amount: 800,
    value: 800,
    label: {
      AZ: '800 AZN (Şəhid ailə üzvləri - Maddə 102.1-1)',
      ENG: '800 AZN (Martyrs family members - Art. 102.1-1)',
      RU: '800 AZN (Члены семей шехидов - Ст. 102.1-1)',
      TR: '800 AZN (Şehit aile fertleri - Madde 102.1-1)',
    },
  },
  {
    amount: 400,
    value: 400,
    label: {
      AZ: '400 AZN (Milli Qəhrəman, Şəhid dul arvadı - Maddə 102.2)',
      ENG: '400 AZN (War heroes, Martyr widows - Art. 102.2)',
      RU: '400 AZN (Герои войны, вдовы шехидов - Ст. 102.2)',
      TR: '400 AZN (Milli Kahraman, Şehit eşi - Madde 102.2)',
    },
  },
  {
    amount: 200,
    value: 200,
    label: {
      AZ: '200 AZN (I və II dərəcə əlillər, Müharibə iştirakçıları - Maddə 102.3)',
      ENG: '200 AZN (1st & 2nd degree disabled, Veterans - Art. 102.3)',
      RU: '200 AZN (Инвалиды I и II гр., Ветераны - Ст. 102.3)',
      TR: '200 AZN (I ve II derece engelliler, Gaziler - Madde 102.3)',
    },
  },
  {
    amount: 100,
    value: 100,
    label: {
      AZ: '100 AZN (Çernobıl, Məcburi köçkünlər - Maddə 102.4)',
      ENG: '100 AZN (Chernobyl, IDPs - Art. 102.4)',
      RU: '100 AZN (Чернобыльцы, вынужденные переселенцы - Ст. 102.4)',
      TR: '100 AZN (Çernobil, Mecburi göçmenler - Madde 102.4)',
    },
  },
  {
    amount: 50,
    value: 50,
    label: {
      AZ: '50 AZN (Himayəsində azı 3 nəfər olanlar - Maddə 102.5)',
      ENG: '50 AZN (At least 3 dependents - Art. 102.5)',
      RU: '50 AZN (Имеющие на иждивении не менее 3 человек - Ст. 102.5)',
      TR: '50 AZN (Bakmakla yükümlü olduğu en az 3 kişi - Madde 102.5)',
    },
  },
];

// Calculator 3: Maternity Translations
export const calc3Dict = {
  title: {
    AZ: 'Hamiləliyə və doğuma görə müavinətin hesablanması (2026 DSMF Qaydaları)',
    ENG: 'Maternity Benefit Calculator (2026 Statutory Rules)',
    RU: 'Расчет пособия по беременности и родам (2026)',
    TR: 'Doğum ve Gebelik Ödeneği Hesaplayıcı (2026 Standartları)',
  },
  sec1Title: {
    AZ: 'Məzuniyyət və Doğuş Parametrləri',
    ENG: 'Maternity Leave & Birth Parameters',
    RU: 'Параметры отпуска и родов',
    TR: 'İzin ve Doğum Parametreleri',
  },
  sec1Sub: {
    AZ: 'Əmək Məcəlləsinin 125-ci maddəsinə uyğun olaraq məzuniyyət müddəti təyin edilir',
    ENG: 'Leave duration determined in accordance with Article 125 of the Labor Code',
    RU: 'Срок отпуска определяется в соответствии со статьей 125 Трудового кодекса',
    TR: 'İş Kanunu Madde 125 uyarınca izin süresi belirlenir',
  },
  startDate: {
    AZ: 'Məzuniyyətin başlama tarixi',
    ENG: 'Leave start date',
    RU: 'Дата начала отпуска',
    TR: 'İzin başlangıç tarihi',
  },
  startDateHint: {
    AZ: 'Hamiləlik bülleteninin açıldığı tarix',
    ENG: 'Date the sick leave certificate was issued',
    RU: 'Дата открытия больничного листа',
    TR: 'Doğum raporunun açıldığı tarih',
  },
  activityType: {
    AZ: 'Fəaliyyət sahəsi',
    ENG: 'Sector / Field of activity',
    RU: 'Сфера деятельности',
    TR: 'Faaliyet alanı',
  },
  actGeneral: {
    AZ: 'Ümumi fəaliyyət (Bütün müəssisələr)',
    ENG: 'General activity (All enterprises)',
    RU: 'Общая деятельность (Все предприятия)',
    TR: 'Genel faaliyet (Tüm işletmeler)',
  },
  actAgriculture: {
    AZ: 'Kənd təsərrüfatı istehsalı',
    ENG: 'Agricultural production',
    RU: 'Сельскохозяйственное производство',
    TR: 'Tarımsal üretim',
  },
  birthType: {
    AZ: 'Doğuş kateqoriyası',
    ENG: 'Birth category',
    RU: 'Категория родов',
    TR: 'Doğum kategorisi',
  },
  birthNormal: {
    AZ: 'Normal doğuş',
    ENG: 'Normal delivery',
    RU: 'Нормальные роды',
    TR: 'Normal doğum',
  },
  birthComplicated: {
    AZ: 'Doğuşun çətinləşməsi',
    ENG: 'Complicated delivery',
    RU: 'Осложненные роды',
    TR: 'Komplikasyonlu doğum',
  },
  birthMultiple: {
    AZ: '2 və daha çox uşaq',
    ENG: 'Multiple birth (2 or more children)',
    RU: 'Многоплодные роды (2 и более детей)',
    TR: 'Çoğul doğum (2 ve daha fazla çocuk)',
  },
  enableActualBirth: {
    AZ: 'Faktiki doğuş tarixi nəzərə alınsın (gecikmə halında uzadılma)',
    ENG: 'Consider actual delivery date (extension in case of delay)',
    RU: 'Учитывать фактическую дату родов (продление при задержке)',
    TR: 'Fiili doğum tarihi dikkate alınsın (gecikme halinde uzatma)',
  },
  seniority: {
    AZ: 'Məcburi dövlət sosial sığorta stajınız (ay)',
    ENG: 'Mandatory social security seniority (months)',
    RU: 'Страховой стаж соцстраха (месяцев)',
    TR: 'Zorunlu sosyal sigorta prim gün/staj süresi (ay)',
  },
  sec2Title: {
    AZ: 'Əvvəlki 4 Ardıcıl Rüb Üzrə Sığorta Qazancı',
    ENG: 'Earnings of Preceding 4 Consecutive Quarters',
    RU: 'Заработок за предыдущие 4 квартала',
    TR: 'Önceki 4 Ardışık Çeyrek Üzerine Sigorta Kazancı',
  },
  hadEmployment: {
    AZ: 'Əvvəlki 4 rübdə əmək fəaliyyətiniz olubmu?',
    ENG: 'Did you have employment in the previous 4 quarters?',
    RU: 'Была ли трудовая деятельность в предыдущих 4 кварталах?',
    TR: 'Önceki 4 çeyrekte çalışma faaliyetiniz oldu mu?',
  },
  yesEmployment: {
    AZ: 'Bəli, əmək fəaliyyətim olub',
    ENG: 'Yes, I had employment',
    RU: 'Да, была трудовая деятельность',
    TR: 'Evet, çalışma faaliyetim oldu',
  },
  noEmployment: {
    AZ: 'Xeyr, fəaliyyət olmayıb (Qaydanın 2.9-cu bəndi - Minimum əməkhaqqı 400 ₼)',
    ENG: 'No, no activity (Clause 2.9 - Minimum wage 400 ₼)',
    RU: 'Нет, деятельности не было (Пункт 2.9 - Минимальная зарплата 400 ₼)',
    TR: 'Hayır, faaliyet olmadı (Madde 2.9 - Asgari ücret 400 ₼)',
  },
  inputMode: {
    AZ: 'Daxiletmə növü:',
    ENG: 'Input mode:',
    RU: 'Тип ввода:',
    TR: 'Giriş türü:',
  },
  modeMDSS: {
    AZ: 'Nəzərə alınan MDSS haqqı üzrə (Bənd 2.7 - Hüquqi əsas)',
    ENG: 'By eligible MDSS contributions (Clause 2.7)',
    RU: 'По учитываемым взносам соцстраха (Пункт 2.7)',
    TR: 'Hesaba katılan sosyal güvenlik primi üzerinden (Madde 2.7)',
  },
  modeEarnings: {
    AZ: 'Rüblük Qazanc / Maaş üzrə (MDSS ekvivalenti ilə)',
    ENG: 'By quarterly earnings / salary (with MDSS equivalent)',
    RU: 'По квартальному заработку / зарплате',
    TR: 'Çeyreklik kazanç / maaş üzerinden (SGK eşdeğeri ile)',
  },
  sec3Title: {
    AZ: 'Çıxılan Təqvim Günləri (ÇTG - Bənd 2.13)',
    ENG: 'Excluded Calendar Days (Clause 2.13)',
    RU: 'Исключаемые календарные дни (Пункт 2.13)',
    TR: 'Düşülen Takvim Günleri (Madde 2.13)',
  },
  addPeriodBtn: {
    AZ: '+ Çıxılan Dövr Əlavə Et',
    ENG: '+ Add Excluded Period',
    RU: '+ Добавить исключаемый период',
    TR: '+ Düşülen Dönem Ekle',
  },
  totalBenefitCard: {
    AZ: 'Hesablanmış Yekun Müavinət Məbləği',
    ENG: 'Total Calculated Benefit Amount',
    RU: 'Итоговая сумма пособия',
    TR: 'Hesaplanan Toplam Ödenek Tutarı',
  },
  taxExemptNotice: {
    AZ: 'Vergidən azaddır: AR Vergi Məcəlləsi Maddə 102.1.4-ə əsasən gəlir vergisi tutulmur.',
    ENG: 'Tax exempt: Under Art. 102.1.4 of the Tax Code, no income tax is deducted.',
    RU: 'Освобождено от налога: по ст. 102.1.4 НК подоходный налог не удерживается.',
    TR: 'Vergiden muaftır: Vergi Kanunu Madde 102.1.4 uyarınca gelir vergisi kesilmez.',
  },
};

// Calculator 4: Termination Grounds (14 statutory items)
export const terminationGrounds = [
  {
    id: '70_b',
    label: {
      AZ: 'ƏM m.70 (b) — İşçilərin sayının və ya ştatların ixtisarı (İxtisar)',
      ENG: 'Labor Code Art. 70 (b) — Redundancy / staff downsizing',
      RU: 'ТК ст. 70 (b) — Сокращение численности или штата работников',
      TR: 'İş Kanunu Madde 70 (b) — Çalışan sayısının veya kadroların azaltılması (İşten çıkarma)',
    },
  },
  {
    id: '70_a',
    label: {
      AZ: 'ƏM m.70 (a) — Müəssisənin ləğv edilməsi',
      ENG: 'Labor Code Art. 70 (a) — Liquidation of enterprise',
      RU: 'ТК ст. 70 (a) — Ликвидация предприятия',
      TR: 'İş Kanunu Madde 70 (a) — İşletmenin tasfiyesi / feshi',
    },
  },
  {
    id: '70_c',
    label: {
      AZ: 'ƏM m.70 (c) — Peşəkarlıq səviyyəsinin uyğun gəlməməsi (attestasiya)',
      ENG: 'Labor Code Art. 70 (c) — Professional inadequacy (attestation)',
      RU: 'ТК ст. 70 (c) — Несоответствие занимаемой должности (аттестация)',
      TR: 'İş Kanunu Madde 70 (c) — Yetersizlik / Mesleki uyumsuzluk (değerlendirme)',
    },
  },
  {
    id: '70_ch',
    label: {
      AZ: 'ƏM m.70 (ç) — Vəzifə öhdəliklərinin kobud şəkildə pozulması',
      ENG: 'Labor Code Art. 70 (ç) — Gross violation of labor duties',
      RU: 'ТК ст. 70 (ç) — Грубое нарушение трудовых обязанностей',
      TR: 'İş Kanunu Madde 70 (ç) — Görev yükümlülüklerinin ağır ihlali',
    },
  },
  {
    id: '68_2_a',
    label: {
      AZ: 'ƏM m.68.2 (a) — Tərəflərin qarşılıqlı razılığı ilə',
      ENG: 'Labor Code Art. 68.2 (a) — Mutual agreement of parties',
      RU: 'ТК ст. 68.2 (a) — По соглашению сторон',
      TR: 'İş Kanunu Madde 68.2 (a) — Tarafların karşılıklı anlaşması (ikale)',
    },
  },
  {
    id: '68_2_b',
    label: {
      AZ: 'ƏM m.68.2 (b) — Müddətli əmək müqaviləsinin müddətinin bitməsi',
      ENG: 'Labor Code Art. 68.2 (b) — Expiration of fixed-term contract',
      RU: 'ТК ст. 68.2 (b) — Истечение срока трудового договора',
      TR: 'İş Kanunu Madde 68.2 (b) — Belirli süreli iş sözleşmesinin sona ermesi',
    },
  },
  {
    id: '69',
    label: {
      AZ: 'ƏM m.69 — İşçinin öz təşəbbüsü ilə (ərizəsi əsasında) istefası',
      ENG: 'Labor Code Art. 69 — Employee voluntary resignation',
      RU: 'ТК ст. 69 — Увольнение по собственному желанию',
      TR: 'İş Kanunu Madde 69 — Çalışanın kendi isteğiyle (istifa) ayrılması',
    },
  },
  {
    id: '74_1_a',
    label: {
      AZ: 'ƏM m.74.1 (a) — Hərbi və ya alternativ xidmətə çağırılma (azı 2.0x OMA)',
      ENG: 'Labor Code Art. 74.1 (a) — Military conscription (min 2.0x average wage)',
      RU: 'ТК ст. 74.1 (a) — Призыв на военную службу (мин. 2.0x зарплата)',
      TR: 'İş Kanunu Madde 74.1 (a) — Askerlik veya alternatif hizmete çağrılma (en az 2.0x ortalama maaş)',
    },
  },
  {
    id: '74_1_b',
    label: {
      AZ: 'ƏM m.74.1 (b) — Əvvəlki işçinin məhkəmə qərarı ilə işə bərpası',
      ENG: 'Labor Code Art. 74.1 (b) — Reinstatement of prior employee by court',
      RU: 'ТК ст. 74.1 (b) — Восстановление прежнего работника по решению суда',
      TR: 'İş Kanunu Madde 74.1 (b) — Önceki çalışanın mahkeme kararıyla işe iadesi',
    },
  },
  {
    id: '74_1_c',
    label: {
      AZ: 'ƏM m.74.1 (c) — Əmək qabiliyyətinin 6 aydan çox fasiləsiz itirilməsi (azı 2.0x OMA)',
      ENG: 'Labor Code Art. 74.1 (c) — Incapacity exceeding 6 continuous months (min 2.0x)',
      RU: 'ТК ст. 74.1 (c) — Утрата трудоспособности более 6 месяцев подряд (мин. 2.0x)',
      TR: 'İş Kanunu Madde 74.1 (c) — 6 aydan uzun süreli aralıksız iş göremezlik (en az 2.0x)',
    },
  },
  {
    id: '74_1_ch',
    label: {
      AZ: 'ƏM m.74.1 (ç) — Məhkəmə hökmü ilə azadlıqdan məhrumetmə və ya cəza',
      ENG: 'Labor Code Art. 74.1 (ç) — Incarceration or penalty under court verdict',
      RU: 'ТК ст. 74.1 (ç) — Лишение свободы по приговору суда',
      TR: 'İş Kanunu Madde 74.1 (ç) — Mahkeme kararıyla hapis veya ceza',
    },
  },
  {
    id: '74_1_d',
    label: {
      AZ: 'ƏM m.74.1 (d) — Məhkəmə qərarı ilə fəaliyyət qabiliyyətsizliyi',
      ENG: 'Labor Code Art. 74.1 (d) — Legal incapacity by court decree',
      RU: 'ТК ст. 74.1 (d) — Признание недееспособным по решению суда',
      TR: 'İş Kanunu Madde 74.1 (d) — Mahkeme kararıyla fiil ehliyetsizliği',
    },
  },
  {
    id: '74_1_e',
    label: {
      AZ: 'ƏM m.74.1 (e) — İşçinin vəfatı və ya itkin düşmüş elan edilməsi (azı 3.0x OMA)',
      ENG: 'Labor Code Art. 74.1 (e) — Death or declaration of missing (min 3.0x)',
      RU: 'ТК ст. 74.1 (e) — Смерть работника или признание пропавшим без вести (мин. 3.0x)',
      TR: 'İş Kanunu Madde 74.1 (e) — Çalışanın vefatı veya gaiplik ilanı (en az 3.0x)',
    },
  },
  {
    id: '63_2_and_68_2_ch',
    label: {
      AZ: 'ƏM m.63.2 və 68.2 (ç) — Mülkiyyətçi dəyişməsi səbəbindən rəhbər heyətlə xitam (azı 3.0x OMA)',
      ENG: 'Labor Code Art. 63.2 & 68.2 (ç) — Termination of executives due to ownership change (min 3.0x)',
      RU: 'ТК ст. 63.2 и 68.2 (ç) — Увольнение руководства при смене собственника (мин. 3.0x)',
      TR: 'İş Kanunu Madde 63.2 ve 68.2 (ç) — Mülkiyet değişikliği nedeniyle yönetici feshi (en az 3.0x)',
    },
  },
];

// Calculator 5: Sick Leave Incident Types
export const sickLeaveIncidentTypes = [
  {
    id: 'ORDINARY_ILLNESS',
    label: {
      AZ: 'Ümumi xəstəlik və ya məişət zədəsi',
      ENG: 'Ordinary illness or household injury',
      RU: 'Общее заболевание или бытовая травма',
      TR: 'Genel hastalık veya ev kazası',
    },
  },
  {
    id: 'WORK_ACCIDENT_OR_OCCUPATIONAL',
    label: {
      AZ: 'İstehsalat qəzası və ya peşə xəstəliyi',
      ENG: 'Work accident or occupational disease',
      RU: 'Производственная травма или профзаболевание',
      TR: 'İş kazası veya meslek hastalığı',
    },
  },
  {
    id: 'SICK_CHILD_CARE',
    label: {
      AZ: 'Xəstə ailə üzvünə (uşağa) qulluq',
      ENG: 'Care for a sick child / family member',
      RU: 'Уход за больным членом семьи (ребенком)',
      TR: 'Hasta aile ferdine (çocuğa) bakım',
    },
  },
  {
    id: 'QUARANTINE',
    label: {
      AZ: 'Karantin',
      ENG: 'Quarantine',
      RU: 'Карантин',
      TR: 'Karantina',
    },
  },
  {
    id: 'SANATORIUM',
    label: {
      AZ: 'Sanatoriya-kurort müalicəsi',
      ENG: 'Sanatorium-resort treatment',
      RU: 'Санаторно-курортное лечение',
      TR: 'Sanatoryum ve kaplıca tedavisi',
    },
  },
];

// Calculator 6: Business Trip
export const calc6Dict = {
  title: {
    AZ: 'Ezamiyyə xərclərinin hesablanması (NK №14 və Vergi Məcəlləsi)',
    ENG: 'Business Trip Expenses Calculator (Decree No. 14 & Tax Code)',
    RU: 'Калькулятор командировочных расходов (Постановление №14 и НК)',
    TR: 'İş Seyahati ve Harcırah Hesaplayıcı (Bakanlar Kurulu No. 14 ve Vergi Kanunu)',
  },
  tripType: {
    AZ: 'Ezamiyyə növü',
    ENG: 'Trip type',
    RU: 'Вид командировки',
    TR: 'Seyahat türü',
  },
  domestic: {
    AZ: 'Ölkədaxili ezamiyyə',
    ENG: 'Domestic business trip',
    RU: 'Внутренняя командировка',
    TR: 'Yurtiçi iş seyahati',
  },
  foreign: {
    AZ: 'Xarici ezamiyyə',
    ENG: 'Foreign business trip',
    RU: 'Зарубежная командировка',
    TR: 'Yurtdışı iş seyahati',
  },
  destinationCity: {
    AZ: 'Təyinat şəhəri / bölgəsi',
    ENG: 'Destination city / region',
    RU: 'Город назначения / регион',
    TR: 'Varış şehri / bölgesi',
  },
  hotelStatus: {
    AZ: 'Mehmanxana xərclərinin sənədləşmə statusu',
    ENG: 'Hotel documentation status',
    RU: 'Статус документов по гостинице',
    TR: 'Konaklama / Otel belgelendirme durumu',
  },
  hotelDocumented: {
    AZ: 'Sənədli (Mehmanxana qəbzi təqdim edilir)',
    ENG: 'Documented (Hotel receipts available)',
    RU: 'С документами (предоставлен чек гостиницы)',
    TR: 'Belgeli (Otel faturası/makbuzu sunuluyor)',
  },
  hotelUndocumented: {
    AZ: 'Sənədsiz (Hüquqi 1 günlük normanın mehmanxana hissəsi)',
    ENG: 'Undocumented (Statutory hotel percentage)',
    RU: 'Без документов (нормативная часть на гостиницу)',
    TR: 'Belgesiz (Yasal otel harcırah oranı)',
  },
  leaderCategory: {
    AZ: 'Rəhbər heyət kateqoriyası (Əlavə faiz)',
    ENG: 'Executive leadership tier (Allowance increment)',
    RU: 'Категория руководства (Надбавка)',
    TR: 'Yönetici kadro kategorisi (Ek artış oranı)',
  },
  hostProvision: {
    AZ: 'Qəbul edən tərəfin təminatı',
    ENG: 'Host provision status',
    RU: 'Обеспечение принимающей стороной',
    TR: 'Karşılayan tarafın sağladığı imkanlar',
  },
  hostNone: {
    AZ: 'Təminat yoxdur (Tam norma ödənilir)',
    ENG: 'No provision (Full norm paid)',
    RU: 'Без обеспечения (Выплачивается полная норма)',
    TR: 'Karşılama yok (Tam harcırah ödenir)',
  },
  hostMeals: {
    AZ: 'Yalnız yemək qarşılanır (Norma %70 azalır)',
    ENG: 'Meals provided only (Norm reduced by 70%)',
    RU: 'Только питание (Норма снижается на 70%)',
    TR: 'Yalnız yemek karşılanıyor (Harcırah %70 azalır)',
  },
  hostFull: {
    AZ: 'Həm yataq, həm yemək qarşılanır (Norma %80 azalır)',
    ENG: 'Both bed and meals provided (Norm reduced by 80%)',
    RU: 'Проживание и питание (Норма снижается на 80%)',
    TR: 'Hem konaklama hem yemek karşılanıyor (Harcırah %80 azalır)',
  },
  salaryPreservation: {
    AZ: 'Modul B: Əməkhaqqının saxlanılması (ƏM m.179)',
    ENG: 'Module B: Salary Preservation (Labor Code Art. 179)',
    RU: 'Модуль B: Сохранение зарплаты (ТК ст. 179)',
    TR: 'Modül B: Maaşın Korunması (İş Kanunu Madde 179)',
  },
  taxAudit: {
    AZ: 'Modul C: Vergi və Mənfəət Auditi (AR VM m.109.7)',
    ENG: 'Module C: Tax & Profit Tax Audit (Tax Code Art. 109.7)',
    RU: 'Модуль C: Налоговый аудит (НК ст. 109.7)',
    TR: 'Modül C: Vergi ve Kurumlar Vergisi Denetimi (Madde 109.7)',
  },
};


// --- Comprehensive Extended Dictionaries for Calculators 3, 4, 5, 6 ---

export const calc3Ext = {
  medHint: {
    AZ: 'Tibbi bülletendə qeyd olunan kateqoriya',
    ENG: 'Category specified in medical certificate',
    RU: 'Категория, указанная в листке нетрудоспособности',
    TR: 'Tıbbi raporda belirtilen kategori',
  },
  birthDelayHint: {
    AZ: 'Doğuş 70 gündən gec olduqda müddət fərq qədər avtomatik uzadılır (Maddə 125.3).',
    ENG: 'If childbirth occurs after 70 days, period is extended accordingly (Art. 125.3).',
    RU: 'При задержке родов свыше 70 дней срок продлевается на число дней задержки (Ст. 125.3).',
    TR: 'Doğum 70 günden geç gerçekleştiğinde süre aradaki fark kadar uzatılır (Madde 125.3).',
  },
  seniorityWarn: {
    AZ: 'Sosial sığorta stajı 6 aydan azdır. Hesablanmış məbləğ yalnız riyazi göstəricidir. Müavinət alma hüququ və faktiki məbləğ DSMF/ƏMAS məlumatları və tətbiq olunan qanunvericilik əsasında müəyyən edilir.',
    ENG: 'Social insurance seniority is under 6 months. The calculated amount is indicative only. Benefit eligibility is determined based on SSPF records and applicable laws.',
    RU: 'Страховой стаж менее 6 месяцев. Сумма носит ознакомительный характер. Право на пособие определяется на основании данных ГФСЗ и законодательства.',
    TR: 'Sosyal güvenlik hizmet süresi 6 aydan azdır. Hesaplanan tutar bilgilendirme amaçlıdır. Hak sahipliği ve fiili tutar SGK kayıtları ve ilgili mevzuat uyarınca belirlenir.',
  },
  basePeriod: {
    AZ: 'Baza dövrü:',
    ENG: 'Base period:',
    RU: 'Базовый период:',
    TR: 'Baz dönem:',
  },
  actualCalDays: {
    AZ: 'Faktiki təqvim günləri:',
    ENG: 'Actual calendar days:',
    RU: 'Фактические календарные дни:',
    TR: 'Fiili takvim günleri:',
  },
  clause2_9Title: {
    AZ: 'Qaydanın 2.9-cu bəndi tətbiq olunur:',
    ENG: 'Rule 2.9 applies:',
    RU: 'Применяется пункт 2.9 Правил:',
    TR: 'Kural 2.9 uygulanır:',
  },
  clause2_9Text: {
    AZ: 'Əvvəlki 4 ardıcıl rübdə əmək fəaliyyəti olmadıqda, orta gündəlik qazanc hadisənin baş verdiyi aydakı minimum aylıq əməkhaqqının həmin aydakı təqvim günlərinin sayına bölünməsi yolu ilə hesablanır.',
    ENG: 'In absence of employment in the preceding 4 consecutive quarters, average daily earnings are calculated by dividing the monthly minimum wage by calendar days of the month.',
    RU: 'При отсутствии трудовой деятельности в предыдущих 4 кварталах среднедневной заработок рассчитывается делением МРОТ на число календарных дней месяца.',
    TR: 'Önceki 4 ardışık çeyrekte çalışma faaliyeti bulunmadığında, ortalama günlük kazanç asgari ücretin ilgili ayın takvim günü sayısına bölünmesiyle hesaplanır.',
  },
  statutoryDeductionsNote: {
    AZ: 'Yalnız normativ hüquqi aktlarla müəyyən edilmiş dövrlər bölən təqvim günlərindən (BTG) çıxılır.',
    ENG: 'Only periods stipulated by statutory regulations are deducted from dividing calendar days.',
    RU: 'Из расчетных календарных дней исключаются только периоды, установленные нормативными актами.',
    TR: 'Yalnız yasal mevzuatla belirlenmiş dönemler bölen takvim günlerinden düşülür.',
  },
  exclIllness: {
    AZ: 'Əmək qabiliyyətinin müvəqqəti itirilməsi (xəstəlik bülleteni)',
    ENG: 'Temporary disability (sick leave)',
    RU: 'Временная нетрудоспособность (больничный лист)',
    TR: 'Geçici iş göremezlik (rapor)',
  },
  exclCare: {
    AZ: 'Qismən ödənişli sosial məzuniyyət (uşağa qulluq)',
    ENG: 'Partially paid social leave (childcare)',
    RU: 'Частично оплачиваемый отпуск по уходу за ребенком',
    TR: 'Kısmi ücretli sosyal izin (çocuk bakımı)',
  },
  exclPregnancy: {
    AZ: 'Hamiləliyə və doğuma görə məzuniyyət',
    ENG: 'Maternity leave',
    RU: 'Отпуск по беременности и родам',
    TR: 'Doğum ve gebelik izni',
  },
  exclUnpaid: {
    AZ: 'Ödənişsiz məzuniyyət',
    ENG: 'Unpaid leave',
    RU: 'Отпуск без сохранения заработной платы',
    TR: 'Ücretsiz izin',
  },
  exclSuspension: {
    AZ: 'İşçinin işdən kənarlaşdırıldığı dövr',
    ENG: 'Suspension from work period',
    RU: 'Период отстранения от работы',
    TR: 'Çalışanın işten uzaklaştırıldığı dönem',
  },
  deleteBtn: {
    AZ: 'Sil',
    ENG: 'Delete',
    RU: 'Удалить',
    TR: 'Sil',
  },
  period: {
    AZ: 'Dövr:',
    ENG: 'Period:',
    RU: 'Период:',
    TR: 'Dönem:',
  },
  formula: {
    AZ: 'Düstur:',
    ENG: 'Formula:',
    RU: 'Формула:',
    TR: 'Formül:',
  },
  quarter: {
    AZ: 'Rüb',
    ENG: 'Quarter',
    RU: 'Квартал',
    TR: 'Çeyrek',
  },
  calRange: {
    AZ: 'Təqvim Aralığı',
    ENG: 'Calendar Range',
    RU: 'Календарный период',
    TR: 'Takvim Aralığı',
  },
  calDays: {
    AZ: 'Təqvim Günləri',
    ENG: 'Calendar Days',
    RU: 'Календарные дни',
    TR: 'Takvim Günleri',
  },
  eligibleMDSS: {
    AZ: 'Nəzərə alınan MDSS haqqı',
    ENG: 'Eligible Social Insurance Fee',
    RU: 'Учитываемый взнос соцстраха',
    TR: 'Dikkate Alınan SGK Primi',
  },
  totalSummary: {
    AZ: 'ÜMUMİ CƏM:',
    ENG: 'TOTAL:',
    RU: 'ИТОГО:',
    TR: 'GENEL TOPLAM:',
  },
  totalCalDays: {
    AZ: 'Faktiki Ümumi Təqvim Günləri (ÜTG):',
    ENG: 'Actual Total Calendar Days:',
    RU: 'Фактические общие календарные дни:',
    TR: 'Fiili Toplam Takvim Günleri:',
  },
  deductedCalDays: {
    AZ: 'Çıxılan Təqvim Günləri (ÇTG):',
    ENG: 'Deducted Calendar Days:',
    RU: 'Исключаемые календарные дни:',
    TR: 'Düşülen Takvim Günleri:',
  },
  totalEarnings: {
    AZ: 'Ümumi Qazanc Məbləği (ÜQM):',
    ENG: 'Total Earnings:',
    RU: 'Общая сумма заработка:',
    TR: 'Toplam Kazanç Tutarı:',
  },
  dailyAverage: {
    AZ: 'Orta Gündəlik Qazanc (OQM):',
    ENG: 'Average Daily Earnings:',
    RU: 'Среднедневной заработок:',
    TR: 'Ortalama Günlük Kazanç:',
  },
  leaveCalDays: {
    AZ: 'Məzuniyyət Təqvim Günləri (TGS):',
    ENG: 'Leave Calendar Days:',
    RU: 'Календарные дни отпуска:',
    TR: 'İzin Takvim Günleri:',
  },
  seniorityStatus: {
    AZ: 'Sosial Sığorta Stajı:',
    ENG: 'Social Insurance Seniority:',
    RU: 'Страховой стаж:',
    TR: 'Sosyal Güvenlik Hizmet Süresi:',
  },
  taxExempt: {
    AZ: 'Gəlir Vergisindən Azad:',
    ENG: 'Income Tax Exempt:',
    RU: 'Освобождение от подоходного налога:',
    TR: 'Gelir Vergisinden Muaf:',
  },
  yesTaxExempt: {
    AZ: 'Bəli (Maddə 102.1.4)',
    ENG: 'Yes (Article 102.1.4)',
    RU: 'Да (Статья 102.1.4)',
    TR: 'Evet (Madde 102.1.4)',
  },
  legalNoticeTitle: {
    AZ: 'Hüquqi Məlumatlandırma Qeydi:',
    ENG: 'Legal Disclaimer Note:',
    RU: 'Правовая оговорка:',
    TR: 'Yasal Bilgilendirme Notu:',
  },
  capNoticeTitle: {
    AZ: 'Aylıq Maksimal Hədd Xəbərdarlığı:',
    ENG: 'Monthly Maximum Limit Warning:',
    RU: 'Предупреждение о месячном лимите:',
    TR: 'Aylık Tavan Sınırı Uyarısı:',
  },
  capNoticeDesc: {
    AZ: 'Qaydanın 3.3-cü bəndinə əsasən, hamiləliyə və doğuma görə müavinətin aylıq məbləği minimum əmək pensiyasının 25 mislindən (8 000 AZN) artıq ola bilməz. Hesablanmış göstərici bu həddi aşdıqda, yekun faktiki məbləğ DSMF-nin elektron sistemi və tətbiq olunan qanunvericilik əsasında müəyyən edilir.',
    ENG: 'Under Rule 3.3, monthly maternity benefit cannot exceed 25 times the minimum labor pension (8,000 AZN). If calculated value exceeds this limit, final amount is determined by SSPF electronic system.',
    RU: 'Согласно пункту 3.3 Правил, месячное пособие не может превышать 25-кратный размер минимальной трудовой пенсии (8 000 AZN). Окончательная сумма определяется электронной системой ГФСЗ.',
    TR: 'Kural 3.3 uyarınca, aylık doğum ödeneği asgari emekli maaşının 25 katını (8 000 AZN) geçemez. Hesaplanan tutar bu sınırı aştığında nihai tutar SGK sistemi tarafından belirlenir.',
  },
};

export const calc4Ext = {
  terminationReasonHint: {
    AZ: 'Xitamın səbəbi müavinət və xəbərdarlıq hüququnu müəyyən edir',
    ENG: 'Termination grounds determine severance and notice entitlements',
    RU: 'Основание увольнения определяет право на выходное пособие и предупреждение',
    TR: 'Fesih gerekçesi kıdem tazminatı ve ihbar haklarını belirler',
  },
  terminationDate: {
    AZ: 'Xitam tarixi',
    ENG: 'Termination date',
    RU: 'Дата расторжения',
    TR: 'Fesih tarihi',
  },
  terminationDateHint: {
    AZ: 'Son iş günü və ya əmək müqaviləsinə xitam verildiyi tarix',
    ENG: 'Last working day or contract termination date',
    RU: 'Последний рабочий день или дата прекращения договора',
    TR: 'Son çalışma günü veya iş sözleşmesinin feshedildiği tarih',
  },
  normDays: {
    AZ: 'Cari ayın iş günləri norması',
    ENG: 'Working days norm of current month',
    RU: 'Норма рабочих дней текущего месяца',
    TR: 'Mevcut ayın çalışma günü normu',
  },
  actualDays: {
    AZ: 'Faktiki işlənmiş iş günləri',
    ENG: 'Actually worked days',
    RU: 'Фактически отработанные дни',
    TR: 'Fiilen çalışılan iş günleri',
  },
  diffTitle: {
    AZ: 'Normativ Mətn vs İnzibati Tətbiq Fərqləri',
    ENG: 'Statutory Text vs Administrative Practice Differences',
    RU: 'Различия нормативного текста и административной практики',
    TR: 'Yasal Metin ile İdari Uygulama Arasındaki Farklar',
  },
  paymentComponent: {
    AZ: 'Ödəniş Komponenti',
    ENG: 'Payment Component',
    RU: 'Компонент выплаты',
    TR: 'Ödeme Kalemi',
  },
  adminMethod: {
    AZ: 'İnzibati Metodika',
    ENG: 'Administrative Methodology',
    RU: 'Административная методика',
    TR: 'İdari Metodoloji',
  },
  altInterpretation: {
    AZ: 'Alternativ İnterpretasiya',
    ENG: 'Alternative Interpretation',
    RU: 'Альтернативная интерпретация',
    TR: 'Alternatif Yorum',
  },
  controlCalculation: {
    AZ: 'Nəzarət Hesabı',
    ENG: 'Control Calculation',
    RU: 'Контрольный расчет',
    TR: 'Kontrol Hesabı',
  },
};

export const calc5Ext = {
  generalIllness: {
    AZ: 'Ümumi xəstəlik və ya məişət zədəsi',
    ENG: 'General illness or domestic injury',
    RU: 'Общее заболевание или бытовая травма',
    TR: 'Genel hastalık veya ev kazası',
  },
  bulletinStart: {
    AZ: 'Bülletenin başlama tarixi',
    ENG: 'Sick leave start date',
    RU: 'Дата начала больничного листа',
    TR: 'Rapor başlangıç tarihi',
  },
  bulletinStartHint: {
    AZ: 'Hadisənin baş verdiyi ilk təqvim günü',
    ENG: 'First calendar day of the incident',
    RU: 'Первый календарный день случая',
    TR: 'Vakanın gerçekleştiği ilk takvim günü',
  },
  bulletinEnd: {
    AZ: 'Bülletenin bitmə tarixi',
    ENG: 'Sick leave end date',
    RU: 'Дата окончания больничного листа',
    TR: 'Rapor bitiş tarihi',
  },
  bulletinEndHint: {
    AZ: 'Son təqvim günü (həmin gün daxil olmaqla)',
    ENG: 'Last calendar day (inclusive)',
    RU: 'Последний календарный день (включительно)',
    TR: 'Son takvim günü (dahil)',
  },
  continuationDaysLabel: {
    AZ: 'Əvvəlki bülleten üzrə işəgötürən tərəfindən ödənilmiş günlərin sayı',
    ENG: 'Days previously paid by employer under prior certificate',
    RU: 'Количество дней, оплаченных работодателем по предыдущему листку',
    TR: 'Önceki rapor kapsamında işveren tarafından ödenmiş gün sayısı',
  },
  employerPaidShare: {
    AZ: 'İşəgötürən Tərəfindən Ödənilən Hissə',
    ENG: 'Share Paid by Employer',
    RU: 'Доля, оплачиваемая работодателем',
    TR: 'İşveren Tarafından Ödenen Kısım',
  },
  dsmfPaidShare: {
    AZ: 'DSMF Tərəfindən Ödənilən Hissə',
    ENG: 'Share Paid by Social Security (SSPF)',
    RU: 'Доля, оплачиваемая ГФСЗ',
    TR: 'SGK Tarafından Ödenen Kısım',
  },
  financingSourcesDays: {
    AZ: 'Maliyyələşmə Mənbələri və Təqvim Günləri Bölgüsü',
    ENG: 'Financing Sources and Calendar Days Distribution',
    RU: 'Источники финансирования и распределение календарных дней',
    TR: 'Finansman Kaynakları ve Takvim Günleri Dağılımı',
  },
  financingSource: {
    AZ: 'Maliyyələşmə Mənbəyi',
    ENG: 'Financing Source',
    RU: 'Источник финансирования',
    TR: 'Finansman Kaynağı',
  },
};

export const calc6Ext = {
  cbarRateHint: {
    AZ: 'Mərkəzi Bankın rəsmi məzənnəsi əsasında',
    ENG: 'Based on official Central Bank exchange rate',
    RU: 'На основе официального курса Центрального банка',
    TR: 'Merkez Bankası resmi kuru üzerinden',
  },
  startDate: {
    AZ: 'Başlama tarixi',
    ENG: 'Start date',
    RU: 'Дата начала',
    TR: 'Başlangıç tarihi',
  },
  endDate: {
    AZ: 'Bitmə tarixi',
    ENG: 'End date',
    RU: 'Дата окончания',
    TR: 'Bitiş tarihi',
  },
  hotelDocStatus: {
    AZ: 'Mehmanxana sənədinin statusu',
    ENG: 'Hotel receipt status',
    RU: 'Статус документов по гостинице',
    TR: 'Konaklama belgesi durumu',
  },
  defaultNormHint: {
    AZ: 'Boş qaldıqda rəsmi norma qədər qəbul edilir',
    ENG: 'If left empty, statutory norm is assumed',
    RU: 'Если не заполнено, принимается официальная норма',
    TR: 'Boş bırakıldığında yasal harcırah normu kabul edilir',
  },
  allDocExpenses: {
    AZ: 'Bütün sənədli və qanuni xərclər daxil',
    ENG: 'Including all documented and statutory expenses',
    RU: 'Включая все подтвержденные и нормативные расходы',
    TR: 'Tüm belgeli ve yasal harcamalar dahil',
  },
  hotelExpense: {
    AZ: 'Mehmanxana Xərci',
    ENG: 'Hotel Expenses',
    RU: 'Расходы на гостиницу',
    TR: 'Konaklama / Otel Harcaması',
  },
  advanceBalance: {
    AZ: 'Avans Balansı Mütəbiqəti',
    ENG: 'Advance Balance Reconciliation',
    RU: 'Сверка авансового отчета',
    TR: 'Avans Bakiyesi Mutabakatı',
  },
  expenseItem: {
    AZ: 'Xərc Maddəsi',
    ENG: 'Expense Item',
    RU: 'Статья расходов',
    TR: 'Gider Kalemi',
  },
  legalBasisNorm: {
    AZ: 'Hüquqi Əsas və Norma',
    ENG: 'Legal Basis & Norm',
    RU: 'Правовое основание и норма',
    TR: 'Yasal Dayanak ve Harcırah Normu',
  },
};
